import { async } from "q";
import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { IListPublicAccountRequest } from "../../../model/base/request/list-public-account-request";
import { ACTION_TYPES, usePublicAccountDispatch } from "./public-account-context";

export const usePublicAccountController = () => {
    const publicAccountDispatch = usePublicAccountDispatch();
    async function loadData(request: IListPublicAccountRequest) {
        try {
            // Limpa os dados antes de carregar novos
            publicAccountDispatch({
                type: ACTION_TYPES.clearData,
            });
            const result = await PortalAppService.listPublicAccount(request);
            publicAccountDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });


        } catch (error) {
            console.log(error);
        }
    }

    async function initalData(request: IListPublicAccountRequest) {
        try {
            // Carrega todas as categorias
            const categories = await BaseAppService.getListCategoryPublication();
            publicAccountDispatch({
                type: ACTION_TYPES.setCategoriesPublication,
                payload: categories,
            });

            if (request.categoryId != undefined) {
                const category = await BaseAppService.getCategoryPublication({ id: request.categoryId });
                publicAccountDispatch({
                    type: ACTION_TYPES.setCategoryPublication,
                    payload: category,
                });
            }

            const subcategories = await BaseAppService.getListSubCategoryPublication({ categoryId: request.categoryId });

            publicAccountDispatch({
                type: ACTION_TYPES.setSubcategoriesPublication,
                payload: subcategories,
            });

            if (request.subcategoryId != undefined) {
                const subcategory = await BaseAppService.getSubCategoryPublication({ id: request.subcategoryId });
                publicAccountDispatch({
                    type: ACTION_TYPES.setSubcategoryPublication,
                    payload: subcategory,
                });
            }
            await loadData(request);
        } catch (error) {
            console.log(error);
        }
    }

    async function loadSubcategories(categoryId: number) {
        try {
            const subcategories = await BaseAppService.getListSubCategoryPublication({ categoryId });
            publicAccountDispatch({
                type: ACTION_TYPES.setSubcategoriesPublication,
                payload: subcategories,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        initalData, loadData, loadSubcategories
    };
}


